<template>
    <div>
        <h5 class="mt-1 mb-4">{{ $t('foreign_student').toUpper() }}</h5>
        <b-row>
            <b-col cols="12" md="4">
                    <div class="label-as-input-div">
                        <label>{{ $t('passport_country') }}</label>
                        <div>
                            {{ getObjectValue(studentProgram, 'passport_country_name') }}
                        </div>
                    </div>
            </b-col>
            <b-col cols="12" md="4">
                <div class="label-as-input-div">
                    <label>{{ $t('passport_number') }}</label>
                    <div>
                        {{ getObjectValue(studentProgram, 'passport_number') }}
                    </div>
                </div>
            </b-col>
            <b-col cols="12" md="4">
                <div class="label-as-input-div">
                    <label>{{ $t('SEVIS ID') }}</label>
                    <div>{{ getObjectValue(studentProgram, 'sevis_id') }}</div>
                </div>
            </b-col>
            <b-col cols="12" md="4">
                <div class="label-as-input-div">
                    <label>{{ $t('Visa Type') }}</label>
                    <div>{{ getObjectValue(studentProgram, 'visa_type_name') }}</div>
                </div>
            </b-col>
        </b-row>

        <b-button variant="primary"
                  @click="updateFormShow"
                  v-if="checkPermission('studentprogram_updateforeign') && editMode">
            {{ $t('edit') }}
        </b-button>

        <CommonModal ref="formModal"
                     size="lg"
                     @bHideModalHeaderClose="clearFormData()"
                     :onHideOnlyX="true"
                     v-if="checkPermission('studentprogram_updateforeign') && editMode">
            >
            <template v-slot:CommonModalTitle>
                {{ $t('foreign_student').toUpper() }}
            </template>
            <template v-slot:CommonModalContent>
                <update-form :studentProgram="studentProgram"
                             @updateFormSuccess="updateFormSuccess()"
                             v-if="formProcess=='update'"
                />
            </template>
        </CommonModal>
    </div>
</template>
<script>
    // Component
    import CommonModal from '@/components/elements/CommonModal';

    // Pages
    import UpdateForm from './UpdateForm';

    export default {
        components: {
            CommonModal,
            UpdateForm
        },
        props: {
            studentProgram: {
                type: Object,
                default: null
            },
            editMode: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                formProcess: null
            }
        },
        methods: {
            // Clear
            clearFormData() {
                this.formProcess = null
            },

            // Update
            updateFormShow() {
                this.formProcess = 'update'
                this.$refs.formModal.$refs.commonModal.show()
            },
            updateFormSuccess() {
                this.clearFormData();
                this.$refs.formModal.$refs.commonModal.hide()
                this.$emit('updatedData', true);
            }
        }
    }
</script>

